import {
  faCalendarDays,
  faCalendarCheck,
  faChartColumn,
  faDumbbell,
  faUser,
  faGear,
  faChartLine,
  faPersonRunning,
  faUsers,
  IconDefinition,
} from "@fortawesome/free-solid-svg-icons";

type NavItem = {
  path: string;
  icon: IconDefinition;
  label: string;
  level: 1 | 2;
};

type RoleNavItems = Record<"trainer" | "admin" | "super_admin" | "client" | "coach", NavItem[]>;

const baseNavItems = {
  trainer: [
    {
      icon: faCalendarDays,
      path: "/programs",
      label: "Programs",
      level: 1,
    },
    {
      icon: faPersonRunning,
      path: "/workouts",
      label: "Workouts",
      level: 1,
    },
    {
      icon: faDumbbell,
      path: "/admin/exercisemanagement",
      label: "Exercises",
      level: 1,
    },
    {
      icon: faUsers,
      path: "/admin/usermanagement",
      label: "Clients",
      level: 1,
    },
    {
      icon: faChartColumn,
      path: "/stats",
      label: "Stats",
      level: 1,
    },
    {
      icon: faChartLine,
      path: "/dashboard",
      label: "Dashboard",
      level: 2,
    },
    {
      icon: faUser,
      path: "/dashboard/profile",
      label: "Profile",
      level: 2,
    },
    {
      icon: faGear,
      path: "/dashboard/settings",
      label: "Settings",
      level: 2,
    },
  ],
  admin: [
    {
      icon: faDumbbell,
      path: "/admin/exercisemanagement",
      label: "Exercises",
      level: 1,
    },
    {
      icon: faUser,
      path: "/dashboard/profile",
      label: "Profile",
      level: 2,
    },
    {
      icon: faGear,
      path: "/dashboard/settings",
      label: "Settings",
      level: 2,
    },
  ],
  super_admin: [
    {
      icon: faUser,
      path: "/dashboard/profile",
      label: "Profile",
      level: 2,
    },
    {
      icon: faGear,
      path: "/dashboard/settings",
      label: "Settings",
      level: 2,
    },
  ],
  client: [
    {
      icon: faChartLine,
      path: "/dashboard",
      label: "Dashboard",
      level: 1,
    },
    {
      icon: faPersonRunning,
      path: "/workouts",
      label: "Workouts",
      level: 1,
    },
    {
      icon: faChartColumn,
      path: "/stats",
      label: "Stats",
      level: 1,
    },
    {
      icon: faCalendarCheck,
      path: "/events",
      label: "Events",
      level: 1,
    },
    {
      icon: faUser,
      path: "/dashboard/profile",
      label: "Profile",
      level: 2,
    },
    {
      icon: faGear,
      path: "/dashboard/settings",
      label: "Settings",
      level: 2,
    },
  ],
};

export const roleSpecificNavItems: RoleNavItems = { ...baseNavItems, coach: [...baseNavItems.trainer] } as RoleNavItems;

for (const items of Object.values(roleSpecificNavItems)) {
  items.push({icon: faChartLine, path: '/goals', label: 'Goals', level: 2});
}
